import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/education/EducationClient.tsx");
